var exports = {
  "G": "AnalyticsPreferencesLink.module__row___d0paa0",
  "n": "AnalyticsPreferencesLink.module__link___d0paa0",
};

module.exports = exports;
